import { Check, Trophy } from "lucide-react";
import { CatFace } from "@/components/yarn/Cat";
import { yarnColor } from "@/lib/api";

export function VotingPanel({ room, send }) {
  const online = room.players.filter((p) => p.connected).length;
  return (
    <div className="space-y-3" data-testid="voting-panel">
      {room.submissions.map((s, i) => {
        const picked = room.my_vote === s.id;
        return (
          <button key={s.id} disabled={s.mine} onClick={() => send("vote", { id: s.id })}
            className={`patch w-full text-left p-5 rise-in transition-colors ${picked ? "!border-[var(--yarn-terracotta)] bg-[#FFF4EC]" : "hover:bg-[var(--yarn-linen)]"} ${s.mine ? "opacity-70 cursor-not-allowed" : ""}`}
            style={{ animationDelay: `${i * 70}ms` }} data-testid={`vote-option-${i}`}>
            <p className="font-story text-lg leading-relaxed">{s.text}</p>
            <div className="mt-3 flex items-center gap-2 text-xs font-display uppercase tracking-wider">
              {s.mine && <span className="text-[var(--yarn-muted)]" data-testid={`vote-option-mine-${i}`}>Your line</span>}
              {picked && <span className="inline-flex items-center gap-1 text-[var(--yarn-terracotta)]" data-testid={`vote-option-picked-${i}`}><Check size={14} /> Your vote</span>}
            </div>
          </button>
        );
      })}
      <p className="text-sm text-[var(--yarn-muted)]" data-testid="vote-progress">{room.vote_count} of {online} votes in. Tap a line to vote (you can change it).</p>
    </div>
  );
}

export function ResultsPanel({ room }) {
  const result = room.last_result;
  if (!result || result.entries.length === 0) {
    return (
      <div className="patch p-7 text-center" data-testid="results-panel">
        <p className="font-display text-lg">Nobody wrote a line this round.</p>
        <p className="text-sm text-[var(--yarn-muted)]">Next round starts in a moment.</p>
      </div>
    );
  }
  const winner = result.entries.find((e) => e.id === result.winner_id);
  const rest = result.entries.filter((e) => e.id !== result.winner_id);
  return (
    <div className="space-y-3" data-testid="results-panel">
      <div className="patch patch-stitched p-6 rise-in bg-[#FFF4EC]" data-testid="winning-line">
        <div className="flex items-center gap-2 font-display text-[var(--yarn-terracotta)]"><Trophy size={18} /> Woven into the story</div>
        <p className="font-story text-xl mt-3 leading-relaxed">{winner.text}</p>
        <div className="mt-3 flex items-center gap-2 text-sm font-display">
          <CatFace id={winner.uid} look={winner.cat} size={32} withYarn /> {winner.author}'s cat grabbed the yarn · {winner.votes} vote{winner.votes === 1 ? "" : "s"}
          {result.tie && <span className="text-[var(--yarn-muted)]">(tie, picked at random)</span>}
        </div>
      </div>
      {rest.map((e, i) => (
        <div key={e.id} className="patch p-4 rise-in flex items-start justify-between gap-3" style={{ animationDelay: `${(i + 1) * 80}ms` }} data-testid={`result-entry-${i}`}>
          <div className="min-w-0">
            <p className="font-story">{e.text}</p>
            <p className="text-xs font-display mt-1" style={{ color: yarnColor(e.uid) }}>{e.author}</p>
          </div>
          <span className="font-display text-sm shrink-0">{e.votes} vote{e.votes === 1 ? "" : "s"}</span>
        </div>
      ))}
    </div>
  );
}
